import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Sidebar from "../components/common/Sidebar";
import HeaderBar from "../components/common/HeaderBar";

const EmployeeLayout = ({ title = "Employee Dashboard" }) => {
  return (
    <Box sx={{ display: 'flex', height: '100vh', bgcolor: '#f5f5f5' }}>
      <Sidebar role="employee" />
      <Box component="main" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <HeaderBar title={title} />
        <Box sx={{ p: 3, flexGrow: 1, overflow: 'auto' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default EmployeeLayout;
